import React from 'react';
import AgencyTemplate from '../components/AgencyTemplate';

const SeismicAcquisition = () => {
	const agencyData = {
		title: "Seismic Acquisition (Land & Marine)",
		subtitle: "Petrochoice Agent for SPLIT",
		description: "Split provide high-quality seismic acquisition services in partnership with Split, covering both land and marine environments. Leveraging advanced technologies and expertise, we deliver accurate subsurface imaging to reduce exploration risks and support efficient field development. Our focus is on safety, reliability, and providing seismic data that drive smarter exploration and production decisions.",
		image: "/assets/logo_eng.png",
		imageAlt: "SPLIT Scientific Company logo",
		features: [
			{
				title: "What They Do",
				description: "SPLIT specializes in marine geophysical and seismoacoustic research, delivering a comprehensive suite of services—from data acquisition to training and supervision. Their mission is to make marine geophysical research accessible, reliable, and high-quality.",
				icon: "bi bi-broadcast-pin",
				iconColor: "#0c61c0"
			},
			{
				title: "Company History & Reach",
				description: "Founded in 2011 with strong ties to MSU marine research entities. Joined the Skolkovo Innovation Center in 2013 to scale commercialization. Developed and deployed SplitMultiSeis and SplitMultiSeis 3D; patents and global conference participation. 100+ marine geophysical projects across Arctic, Black, Caspian, Baltic, Sea of Japan, and major lakes.",
				icon: "bi bi-globe",
				iconColor: "#28a745"
			}
		],
		additionalSections: [
			{
				title: "Core Service Offering",
				items: [
					[
						{ icon: "bi bi-broadcast-pin", iconColor: "#dc3545", title: "Geophysical Surveys", description: "UHR seismic, profiling, side-scan sonar, multibeam, magnetics, VSP" },
						{ icon: "bi bi-cpu", iconColor: "#6c757d", title: "Data Processing & Interpretation", description: "Real-time QC, amplitude-preserving processing, hazard mapping, structural/amplitude interpretation" }
					],
					[
						{ icon: "bi bi-diagram-3", iconColor: "#007bff", title: "Technologies & Equipment", description: "SplitMultiSeis, SplitMultiSeis 3D, Sorex Pro, SplitGunDeepMaster, DAS, bottom multi-component" },
						{ icon: "bi bi-mortarboard", iconColor: "#17a2b8", title: "Innovation, Training & Supervision", description: "R&D, software/hardware, courses, supervision and QC across projects" }
					]
				]
			}
		]
	};

	return <AgencyTemplate {...agencyData} />;
};

export default SeismicAcquisition;
